import React from "react";
import { Paper, Tab, Tabs } from "material-ui";
import Button from "../../components/EmailAddressBook/Button";
import { FormattedMessage, injectIntl } from "react-intl";
import QuestionnaireTable from "../../components/Questionnaire/QuestionnaireTable";
import AddQuestionnaire from "../../components/Questionnaire/AddQuestionnaire";
import { getPlan } from "../../lib";
import ReactTooltip from "react-tooltip";
import TemplateTableDialog from "../../components/Questionnaire/TemplateTableDialog";
import QuestionnaireResult from "../../components/Questionnaire/QuestionnaireResult";
import ResultTable from "../../components/Questionnaire/ResultTable";

const styles = {
  tabInkStyle: {
    display: 'none'
  },
  tabsStyle: {
    backgroundColor: "#F6F9FC",
    width: "340px",
    borderRadius: "12px",
    // boxShadow: "rgb(0 0 0 / 12%) 0px 1px 6px, rgb(0 0 0 / 12%) 0px 1px 4px",
  },
  tabItemContentStyle: {
    backgroundColor: "#F6F9FC",
    borderTopLeftRadius: "12px",
    borderTopRightRadius: "12px",
  },
};

class Questionnaire extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openAddQuestionnaire: false,
      rooms: [],
      selectedQuestionnaire: null,
      openTemplateDialog: false,
      selectedTemplate: null,
      selectedTemplateToFill: null,
      openQuestionnaireResult: false,
      selectedResult: null,
      isRoomFetched: false,
      selectedTab: "list",
      reRegister: false
    };
  }

  componentDidMount() {
    this.getRoom();
    this.props.getQuestionnaires();
    this.props.getTemplates();
  }

  getRoom = async () => {
    const res = await getPlan(1);
    if (res.data && res.data.hasOwnProperty("rooms")) {
      this.setState({
        rooms: res.data.rooms.map((room) => {
          room.isVisible = true;
          return room;
        }),
        isRoomFetched: true,
      });
    } else {
      this.setState({ isRoomFetched: true });
    }
  };

  handleSearch = (event) => {
    let rooms = this.state.rooms;
    rooms = rooms.map((room) => {
      room.isVisible = room.fvroom_name.includes(event.target.value);
      if (event.target.value === "") {
        room.isVisible = true;
      }
      return room;
    });

    this.setState({ rooms });
  };

  handleEdit = (questionnaire, reRegister = false) => {
    this.setState(
      {
        selectedQuestionnaire: questionnaire,
        selectedTemplate: null,
        selectedTemplateToFill: null,
        reRegister
      },
      () => {
        this.setState({ openAddQuestionnaire: true });
      }
    );
  };

  handleTemplateEdit = (template) => {
    this.setState(
      {
        selectedQuestionnaire: null,
        selectedTemplate: template,
        selectedTemplateToFill: null,
      },
      () => {
        this.setState({ openAddQuestionnaire: true });
      }
    );
  };

  addTemplateToQuestionnaire = (template) => {
    this.setState(
      {
        selectedTemplateToFill: template,
        selectedQuestionnaire: null,
        selectedTemplate: null,
      },
      () => {
        this.setState({ openAddQuestionnaire: true });
      }
    );
  };

  showResult = (questionnaire) => {
    this.setState({ selectedResult: questionnaire }, () => {
      this.setState({ openQuestionnaireResult: true });
    });
  };

  resetState = () => {
    this.setState({
      openAddQuestionnaire: false,
      selectedQuestionnaire: null,
      selectedTemplate: null,
      selectedTemplateToFill: null,
    });
  };

  render() {
    const texts = {
      templateHint: this.props.intl.formatMessage({
        id: "questionnaire.templateHint",
      }),
    };
    return (
      <div>
        <Tabs
          inkBarStyle={styles.tabInkStyle}
          style={styles.tabsStyle}
          tabItemContainerStyle={styles.tabItemContentStyle}
          onChange={(selectedTab) => this.setState({ selectedTab })}
        >
          <Tab
            style={{ backgroundColor: this.state.selectedTab === 'list' ?  "#6b7c93" : "#bbc5e2", borderTopLeftRadius: "16px", borderTopRightRadius: "16px", border: "1.5px solid #435b8d", }}
            buttonStyle={{
              fontSize: "13px",
            }}
            label={<FormattedMessage id="questionnaire.questionnaireList" />}
            value="list"
          ></Tab>
          <Tab
            buttonStyle={{
              fontSize: "13px",
            }}
            value="result"
            style={{ backgroundColor: this.state.selectedTab === 'result' ?  "#6b7c93" : "#bbc5e2", borderTopLeftRadius: "16px",  borderTopRightRadius: "16px", border: "1.5px solid #435b8d", }}
            label={<FormattedMessage id="questionnaire.result" />}
          ></Tab>
        </Tabs>

        <Paper style={{ borderRight: "2px solid #e3e3e3", padding: "10px", }}>
          <ReactTooltip place="top" multiline effect="solid" html />

          {this.state.openAddQuestionnaire && (
            <AddQuestionnaire
              open={this.state.openAddQuestionnaire}
              handleClose={this.resetState}
              rooms={this.state.rooms}
              handleSearch={this.handleSearch}
              selectedQuestionnaire={this.state.selectedQuestionnaire}
              selectedTemplate={this.state.selectedTemplate}
              selectedTemplateToFill={this.state.selectedTemplateToFill}
              onSuccess={() => {
                this.props.getQuestionnaires();
                this.props.getTemplates();
                this.resetState();
              }}
              reRegister={this.state.reRegister}
            />
          )}

          {this.state.openTemplateDialog && (
            <TemplateTableDialog
              open={this.state.openTemplateDialog}
              handleClose={() => {
                this.setState({ openTemplateDialog: false });
              }}
              templates={this.props.templates}
              isFetchingTemplates={this.props.isFetchingTemplates}
              editTemplate={this.handleTemplateEdit}
              addTemplateToQuestionnaire={this.addTemplateToQuestionnaire}
            />
          )}

          {this.state.openQuestionnaireResult && this.state.selectedResult && (
            <QuestionnaireResult
              open={this.state.openQuestionnaireResult}
              handleClose={() =>
                this.setState({ openQuestionnaireResult: false })
              }
              selectedResult={this.state.selectedResult}
            />
          )}

          {this.state.selectedTab === "list" && (
            <div>
               <ReactTooltip place="top" multiline effect="solid" html />
              <Button
                label={<FormattedMessage id="questionnaire.createNew" />}
                handleButtonClick={() => {
                  this.setState({ openAddQuestionnaire: true });
                }}
                help={false}
                minWidth="unset"
                className="email-page-button questionnaire m-width-100"
              />
              <Button
                label={<FormattedMessage id="questionnaire.template" />}
                handleButtonClick={() => {
                  this.setState({ openTemplateDialog: true });
                }}
                minWidth="unset"
                className="email-page-button questionnaire m-width-100"
              />
              <QuestionnaireTable
                questionnaires={this.props.questionnaires}
                isFetching={this.props.isFetching}
                editQuestionnaire={this.handleEdit}
                showResult={this.showResult}
                rooms={this.state.rooms}
                isRoomFetched={this.state.isRoomFetched}
              />
            </div>
          )}

        {this.state.selectedTab === "result" && (
          <div>
            <ResultTable
              questionnaires={this.props.results}
              isFetching={this.props.isFetching}
              editQuestionnaire={this.handleEdit}
              showResult={this.showResult}
              rooms={this.state.rooms}
              isRoomFetched={this.state.isRoomFetched}
            />
          </div>
        )}
        </Paper>
      </div>
    );
  }
}

export default injectIntl(Questionnaire);



// WEBPACK FOOTER //
// src/routes/Questionnaire/Questionnaire.js